import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView'
import NotFoundView from '@/views/NotFoundView'
import PostView from '@/views/PostView'
import ApiSite from '@/classes/ApiSite'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'routes-home',
    component: HomeView
  },
  {
    path: '/kit',
    name: 'routes-kit',
    component: () => import('../views/KitView'),
    children: [
      {
        path: ':index',
        component: () => import('../views/KitView')
      }
    ]
  },
  {
    path: '/post/:code/mobile',
    name: 'routes-post-mobile',
    params: { mobile: true },
    component: PostView,
    meta: { isLegacyUrl: true }
  },
  {
    path: '/post/:code-:hash',
    name: 'routes-post-hash',
    component: PostView,
    meta: { isLegacyUrl: true }
  },
  {
    path: '/post/:code',
    name: 'routes-post',
    component: PostView,
    meta: { isLegacyUrl: true }
  },
  {
    path: '/:slug',
    name: 'routes-post-slug',
    component: PostView,
    meta: { isSlugUrl: true }
  },
  {
    path: '/:pathMatch(.*)',
    component: NotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => {
    return {
      left: 0,
      top: 0
    }
  }
})

// Редирект со старых URL на новые slug-based
router.beforeEach((to, from, next) => {
  if (!to.meta.isLegacyUrl || !to.params.code || ApiSite.getLanguage() !== 'ru') {
    next()
    return
  }

  const slug = store.getters.getValueToSlug[to.params.code]
  if (slug) {
    next({ path: `/${slug}`, replace: true })
    return
  }

  next()
})

export default router
